import * as React from "react";
const SvgHills = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_7713_487984)" }, /* @__PURE__ */ React.createElement("rect", {
	width: 36,
	height: 36,
	rx: 8,
	fill: "#F2F3F7"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12.2983 42.8428C9.48313 40.0275 8.07552 38.6199 7.54813 36.9968C7.08422 35.569 7.08422 34.0311 7.54813 32.6033C8.07552 30.9802 9.48313 29.5725 12.2983 26.7573L17.1575 21.8982C19.9727 19.083 21.3803 17.6754 23.0034 17.148C24.4312 16.6841 25.9692 16.6841 27.3969 17.148C29.0201 17.6754 30.4277 19.083 33.2429 21.8982L38.1021 26.7573C40.9173 29.5725 42.3249 30.9802 42.8523 32.6033C43.3162 34.0311 43.3162 35.569 42.8523 36.9968C42.3249 38.6199 40.9173 40.0275 38.1021 42.8428L33.2429 47.7019C30.4277 50.5171 29.0201 51.9247 27.3969 52.4521C25.9692 52.916 24.4312 52.916 23.0034 52.4521C21.3803 51.9247 19.9727 50.5171 17.1575 47.7019L12.2983 42.8428Z",
	fill: "#BCC3D0",
	fillOpacity: .25,
	style: { mixBlendMode: "multiply" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M-8.42553 46.025C-11.7246 42.726 -13.3741 41.0764 -13.9922 39.1743C-14.5358 37.5012 -14.5358 35.6988 -13.9922 34.0257C-13.3741 32.1236 -11.7246 30.474 -8.42554 27.175L0.775073 17.9744C4.07414 14.6753 5.72368 13.0258 7.62579 12.4077C9.29894 11.8641 11.1013 11.8641 12.7744 12.4077C14.6765 13.0258 16.3261 14.6753 19.6251 17.9744L28.8257 27.175C32.1248 30.474 33.7743 32.1236 34.3924 34.0257C34.936 35.6988 34.936 37.5012 34.3924 39.1743C33.7743 41.0764 32.1248 42.726 28.8257 46.025L19.6251 55.2256C16.3261 58.5247 14.6765 60.1742 12.7744 60.7923C11.1013 61.3359 9.29894 61.3359 7.62579 60.7923C5.72368 60.1742 4.07414 58.5247 0.775082 55.2256L-8.42553 46.025Z",
	fill: "#BBC1C7"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M25.2002 9C25.2002 10.6569 23.857 12 22.2002 12C20.5433 12 19.2002 10.6569 19.2002 9C19.2002 7.34315 20.5433 6 22.2002 6C23.857 6 25.2002 7.34315 25.2002 9Z",
	fill: "white"
})), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_7713_487984" }, /* @__PURE__ */ React.createElement("rect", {
	width: 36,
	height: 36,
	rx: 8,
	fill: "white"
}))));
export default SvgHills;
